/**
 * Format number to string with commas
 * @param {number} x
 * @return {string}
 */
export const format = (x: number) => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
